var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-432 -144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m437 172.829v13.171c0 2.761 2.239 5 5 5h6c1.657 0 3-1.343 3-3v-12c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v12c0 1.657 1.343 3 3 3h6c2.761 0 5-2.239 5-5v-13.517c.317-.144.614-.347.875-.608 0 0 2-2 2-2 1.171-1.172 1.171-3.071 0-4.243 0 0-19.754-19.753-19.754-19.753-1.171-1.172-3.071-1.172-4.242 0 0 0-20 20-20 20-1.172 1.171-1.172 3.071 0 4.242 0 0 2 2 2 2 .327.328.711.564 1.121.708zm36-.171c-.501-.13-.975-.391-1.368-.783 0 0-15.632-15.632-15.632-15.632s-15.879 15.878-15.879 15.878c-.327.328-.711.564-1.121.708v13.171c0 1.657 1.343 3 3 3h6c.552 0 1-.448 1-1v-12c0-1.657 1.343-3 3-3h8c1.657 0 3 1.343 3 3v12c0 .552.448 1 1 1h6c1.657 0 3-1.343 3-3zm-16.293-25.365 19.754 19.753c.39.391.39 1.024 0 1.415 0 0-2 2-2 2-.391.39-1.024.39-1.415 0 0 0-16.339-16.34-16.339-16.34-.39-.39-1.024-.39-1.414 0l-16.586 16.586c-.39.391-1.024.391-1.414 0 0 0-2-2-2-2-.391-.39-.391-1.024 0-1.414 0 0 20-20 20-20 .39-.391 1.024-.391 1.414 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.a97499270f0c1ff6af943bcf04a6f4f0.svg";
export { ForwardRef as ReactComponent };